cv.DonationsView = Marionette.CompositeView.extend({
  template : cv.Templates['donations/list'],
  childViewContainer: '.donations-list',
  childView: cv.DonationsRowView,
  emptyView: cv.DonationsRowEmptyView,

  events: {
    'click .export-donations' : 'exportDonations'
  },

  behaviors: [],

  childEvents: {
    'show' : function() {
    },
    'render' : function() {
    }
  },

  childViewOptions: function(model, index) {
    // do some calculations based on the model
    return {
      // Pass the current tab
    }
  },

  initialize: function(options){
    this.mergeOptions(options, this.options);

    // Set as current project
    this.collection.params.project_id = cv.project.get('id');
    this.collection.params.limit = 1000;

    console.log('DonationsView initialized');
  },

  exportDonations: function(e){
    e.preventDefault();

    window.location = cv.api_path + '/projects/' + cv.project.get('id') + '/export_donations?api_key=' + cv.PRELOADED.api_key;
  },

  isEmpty: function(collection){
    if(collection.num_records > 0 || _.isUndefined(collection.num_records)){
      return false;
    }
    if(collection.num_records == 0){
      return true;
    }
  },

  attachHtml: function(collectionView, childView, index){
    if (collectionView.isBuffering) {
      // buffering happens on reset events and initial renders
      // in order to reduce the number of inserts into the
      // document, which are expensive.
      collectionView._bufferedChildren.splice(index, 0, childView);
    }else {
      // If we've already rendered the main collection, append
      // the new child into the correct order if we need to. Otherwise
      // append to the end.
      if (!collectionView._insertBefore(childView, index)){
        collectionView._insertAfter(childView);
      }
    }
  },

  templateHelpers: function(){
    return {
    }
  },

  onBeforeShow: function(){
  },

  onAttach: function(){ 
    this.collection.fetch({
      reset: true
    });
  },

  onDestroy: function(){
  }
});